module.exports = __webpack_public_path__ + "img/selected7-min.a0438ee3.png";